export default {
	searchParams: {
		pgmId: null,
		jobGroupId: null,
		jobId: null,
		jobNm: null,
		useYn: null		
	},
	batchStatusList: [],
	useYnList: [], //조회조건에 사용여부	
	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	}
};
